import DefaultPage, {
  getServerSideProps as defaultServerSideProps,
} from "grandus-lib/pages/search/search.default";

export async function getServerSideProps(context) {
  return defaultServerSideProps(context);
}

export default DefaultPage;
